export default {
	LaunchedMonth: {
		1: '1月上线',
		2: '2月上线',
		3: '3月上线',
		4: '4月上线',
		5: '5月上线',
		6: '6月上线',
		7: '7月上线',
		8: '8月上线',
		9: '9月上线',
		10: '10月上线',
		11: '11月上线',
		12: '12月上线',
		13: '即将上线'
	},
	menu: {
		home: '首页',
		hotGame: '热门游戏',
		tryPlay: '游戏试玩',
		ourAdvantage: '我们的优势',
		aboutUs: '关于我们',
		linkUs: '联系我们',
		login: '登录',
		register: '注册'
	},
	indexPagePlay: {
		players: '在线玩家：129003',
		webTitle: '全球最顶尖的游戏开发商',
		gameTry1: '游戏试玩',
		gameTry2: '游戏试玩',
		bannerExplain: '纯3D引擎打造极致3D效果，身临其境如同现实博弈  海量游戏集成，为您量身定制，后续不断更新',
		inGame: '进入游戏',
		development: '开发中,敬请期待'
	},
	banner: {
		coming: '敬请期待',
		baijiale: '百家乐',
		lunpan: '欧式轮盘',
		buyu: '3D千炮捕鱼王',
		zhanjinhua: '炸金花',
		niuniu: '抢庄牛牛',
		tuiTongzi: '百人推筒子',
		longhu: '龙虎斗',
		dezhou: '德州扑克',
		jisuhua: '极速炸金花',
		shisanshui: '十三水',
		// runFast: '跑得快',
		paijiu: '通比牌九',
		// doudizhu: '斗地主',
		kingOfFishing3D: '捕鱼王中王',
		shidianban: '十点半',
		sangong: '三公',
		ershiyidian: '二十一点',
		bairenbaijiale: '百人百家乐',
		honghei: '红黑大战',
		niuniu4: '看牌抢庄牛牛',
		bairenniuniu: '百人牛牛',
		benzAndBMW: '奔驰宝马',
		majiangxueliu: '麻将（血流）',
		forestParty: '森林舞会',
		majiangxuezhan: '麻将（血战）',
		landlord: '斗地主（不洗牌）',
		jinsaPoker: '金沙扑克',
		fanbeimajiang: '翻倍血流',
		pirateFishing: '3D海盗来了',
		mermaidFishing: '3D美人渔',
		dezhou_qz: '德州扑克（前注场）',
		errenmj: '二人麻将',
		ksznn_3d: '3D看四张牛牛',
		qznn_3d: '3D抢庄牛牛',
		ddzjs: '极速斗地主',
		jokerNiuniu: '癞子牛牛',
		lkpy: '李逵劈鱼',
		dntg: '大闹天宫',
		birdingJoy: '捕鸟达人',
		goldenCountry: '黄金国度'
	},
	bannerSmallTitle: {
		baijiale: 'BACCARAT',
		lunpan: 'ROULETTE',
		buyu: 'CANNON FISHING',
		zhanjinhua: 'GOLDEN FLOWER',
		niuniu: 'BANKER NIU NIU',
		tuiTongzi: 'CIRCLE TILES',
		longhu: 'DRAGON&TIGER',
		dezhou: 'TEXAS HOLDEM',
		jisuhua: 'SPEED FLOWER',
		shisanshui: 'THIRTEEN POKER',
		// runFast: 'RUN FAST',
		paijiu: 'PAI GOW',
		// doudizhu: "LANDLORDS",
		kingOfFishing3D: 'KING OF FISHING',
		shidianban: 'TEN POINT HALF',
		sangong: 'THREE FACECARD',
		ershiyidian: 'BLACKJACK',
		bairenbaijiale: 'MULTI-PLAYERS BACCARAT',
		honghei: 'RED & BLACK',
		niuniu4: 'Banker Niu Niu （Cards Shown）',
		bairenniuniu: 'MULTI-PLAYERS NIU-NIU',
		majiangxueliu: 'BLOOD FLOW MAHJONG',
		benzAndBMW: 'BENZ & BMW',
		forestParty: 'FOREST PARTY',
		majiangxuezhan: 'BLOOD STATION MAHJONG',
		landlord: 'LANDLORD（NO SHUFFLE)',
		jinsaPoker: 'JINSA POKER',
		fanbeimajiang: 'DOUBLE BLOOD',
		pirateFishing: '3D PIRATE FISHING',
		mermaidFishing: '3D MERMAID FISHING',
		dezhou_qz: 'TEXAS HOLDEM(ANTE)',
		errenmj: '2 persons mahjong',
		ksznn_3d: '3D FOUR CARDS SHOWN NIUNIU',
		qznn_3d: '3D BANKER NIUNIU',
		ddzjs: 'SPEED LANDLORDS',
		jokerNiuniu: 'JOKER NIUNIU',
		lkpy: 'FISHING KUI LEE',
		dntg: 'MONKEY KING',
		birdingJoy: 'BIRDING JOY',
		goldenCountry: 'GOLDEN COUNTRY'
	},
	ourAdvantage: {
		title1: '万兆光纤接入',
		content1: '高密度光纤连接平台，让用户体验什么叫快如闪电',
		title2: '多层网络保护',
		content2: '高防CDN,云防加速，我们何止是快，我们稳如泰山',
		title3: '快捷API接入',
		content3: '我们提供简单快捷的API接入解决方案，想怎么接就怎么接',
		title4: '3D游戏引领',
		content4: '业内纯3D引擎打造，产品体验畅快，进入即是一场身临其境的完美游戏盛宴',
		title5: '权威机构认证',
		content5: '游戏经权威机构测试漏洞并给予专业认证，运行稳定是我们的宗旨',
		title6: '一号全网通',
		content6: '电脑、IOS、iPad、安卓设备，无障碍的跨平台应用，用户放心下畅快玩',
		title7: '运维经验丰富',
		content7: '10年运营维护经验，获CCIE、CCNP、CCNA认证资格',
		title8: '客服团队专业',
		content8: '7* 24小时专业客服团队，更有资深专业工程师全天候为您提供服务'
	},
	aboutUs: {
		p1: '百胜棋牌是一家专注于棋牌游戏市场的游戏开发商。',
		p2: '我们致力于用最先进的3D技术打造最完美的视听盛宴，带给玩家身临其境般的享受；',
		p3: '我们致力于给玩家带来公平公正，有趣流畅的游戏平台；',
		p4: '我们致力于帮助商户平台提升产品竞争力和用户活跃度，丰富商户平台的运营手段，降低其研发成本。',
		moreGameTitle: '更多游戏，敬请期待',
		gameToggleInfo: '学习先行者，创造自我，超越无我'
	},
	NavTitle: {
		online: '已上线',
		qipaiKind: '棋牌类',
		electronGame: '电子类',
		MahjongKing: '麻将类',
		hunterKing: '捕猎类'
	},
	gameName: {
		online: {
			a: '百家乐',
			b: '欧式轮盘',
			c: '3D千炮捕鱼王',
			d: '炸金花',
			e: '抢庄牛牛',
			f: '百人推筒子',
			g: '龙虎斗',
			h: '德州扑克',
			i: '极速炸金花',
			j: '跑得快',
			k: '十三水',
			l: '通比牌九',
			m: '斗地主',
			n: '捕鱼王中王',
			u: '十点半',
			v: '三公',
			lkpy: '李逵劈鱼',
			dntg: '大闹天宫',
			birdingJoy: '捕鸟达人',
			goldenCountry: '黄金国度'
		},
		qipaiKind: {
			zhajinhua3d: '3D炸金花',
			bairen: '百人推筒子',
			niniu: '通比牛牛',
			tongbi: '通比推筒子',
			paijiu: '抢庄牌九',
			guandao: '掼蛋',
			sangong: '三公',
			jialebipuke: '加勒比扑克',
			ershiyidian: '二十一点',
			paohuzi: '跑胡子',
			shaibao: '骰宝',
			bairenniuniu: '百人牛牛',
			sanzhangpuke: '三张扑克',
			doudizhu1: '极速斗地主',
			doudizhu2: '斗地主（不洗牌）',
			qiangzhuangtuitongzi: '抢庄推筒子',
			shidianban: '十点半',
			jokerNiuniu: '癞子牛牛',
			kszqznn: '看三张抢庄牛牛',
			developGame: '更多游戏'
		},
		electronGame: {
			laohuji: '老虎机',
			senlinwuhui: '森林舞会',
			taiqiudashi: '台球大师',
			benchibaoma: '奔驰宝马',
			shuiguopaidui: '水果派对',
			feiqinzoushou: '飞禽走兽',
			wangzhezuqiu: '王者足球',
			hangjinlunpan: '黄金轮盘',
			xingyunwu: '幸运五',
			developGame: '更多游戏'
		},
		MahjongKing: {
			guangdongmajiang: '广东麻将',
			zhuajimajiang: '抓鸡麻将',
			dongbeimajiang: '东北麻将',
			errenmajiang: '二人麻将',
			xueliumajiang: '血流麻将',
			fanbeimajiang: '翻倍血流',
			taimajiang: '台湾麻将',
			guojimajiang: '国际麻将',
			hangzhoumajiang: '杭州麻将',
			kawufumajiang: '卡五福麻将',
			xuezhanmajiang: '血战麻将',
			fuzhoumajiang: '福州麻将',
			zhongyongmajiang: '中庸麻将'
		},
		hunterKing: {
			buniaolueshou: '捕鸟猎手',
			xingjidazhan: '星际大战',
			xingyunbuyu: '幸运捕鱼',
			developGame: '更多游戏'
		}
	},
	linkUs: {
		title: '敬请留下您的联系方式',
		name: '姓名',
		mail: '邮箱',
		phone: '手机',
		remark: '说明',
		btnTxt: '提交',
		captcha: '验证码',
		messages: {
			noName: '请提供一个称呼,方便客服联系您！',
			noContact: '请提供一个联系方式，邮箱或者电话请填写一个！',
			noRemark: '请说明下您遇到的或者想了解的情况，至少10个字以上！',
			remarkLength: '说明信息的长度不够！',
			mailError: '邮箱格式错误！',
			phoneError: '电话号码格式错误!'
		}
	}
};



// WEBPACK FOOTER //
// ./src/lang/zh.js